import { render, staticRenderFns } from "./rest_rkeeper.vue?vue&type=template&id=3b58f0e5&scoped=true&"
import script from "./rest_rkeeper.vue?vue&type=script&lang=js&"
export * from "./rest_rkeeper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58f0e5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b58f0e5')) {
      api.createRecord('3b58f0e5', component.options)
    } else {
      api.reload('3b58f0e5', component.options)
    }
    module.hot.accept("./rest_rkeeper.vue?vue&type=template&id=3b58f0e5&scoped=true&", function () {
      api.rerender('3b58f0e5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/restaurants/item/tabs/rkeeper/rest_rkeeper.vue"
export default component.exports